import autobind from 'autobind-decorator';
import { Location } from 'history';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import * as Actions from '../../../../common/services/app/Actions';
import * as AppService from '../../../../common/services/app/Service';
import { AppActionPropTypes } from '../../../../common/services/app/Types';
import * as CommonAuthService from '../../../../common/services/auth';
import { ConfigProp, IsReadyToRenderProp, RenderPropWithProps, RouteProps, TranslationFuncProp } from '../../../../common/types/prop-types/common';
import menuCloseIcon from '../../../assets/images/menuCloseIcon.svg';
import menuIconMINI from '../../../assets/images/menuIcon-mini.svg';
import menuIconBMW from '../../../assets/images/menuIcon.svg';
import { RootState } from '../../../base/RootReducer';
import { config } from '../../../common';
import { AppThunkDispatch } from '../../../common/types';

export interface SideNavProps extends IsReadyToRenderProp, ConfigProp {
    showMenu: boolean;
    menuIcon: any;
    onClick: (event: React.MouseEvent<{}> | null) => void;
}

export interface SideNavContainerProps { }

interface ReduxStateProps {
    goBackUrl?: Location<any>;
}

interface ReduxDispatchProps {
    authServiceActions: CommonAuthService.Service.ServiceActions;
    appActions: typeof Actions;
    appServiceActions: AppService.ServiceActions;
}

interface SideNavContainerState {
    showMenu: boolean;
    iconMenu: any;
}

class SideNavContainer extends Component<
    SideNavContainerProps &
    TranslationFuncProp &
    RouteProps &
    RenderPropWithProps<SideNavProps> &
    ReduxStateProps &
    ReduxDispatchProps,
    SideNavContainerState
    > {
    public static propTypes = {
        t: PropTypes.func.isRequired,
        routeProps: PropTypes.any.isRequired,
        authServiceActions: CommonAuthService.Service.ServiceActionPropTypes,
        appActions: AppActionPropTypes.isRequired,
        appServiceActions: AppService.ServiceActionPropTypes.isRequired,
        goBackUrl: PropTypes.any,
        //
        children: PropTypes.func.isRequired,
    };

    public readonly state: SideNavContainerState = {
        showMenu: false,
        iconMenu: menuIconBMW,
    };

    @autobind
    public async onClick(e: React.MouseEvent<{}> | null) {
        if (e) {
            e.preventDefault();
        }
        if (!this.props.goBackUrl) {
            await this.props.appServiceActions.menuGoBackUrl(this.props.routeProps.location);
            this.props.routeProps.history.push(config.BaseURL);
        } else if (this.props.routeProps.match.url !== this.props.routeProps.location.pathname) {
            await this.props.appServiceActions.menuGoBackUrl(this.props.routeProps.location);
            this.props.routeProps.history.push(config.BaseURL);
        } else {
            this.props.routeProps.history.goBack();
        }
    }

    @autobind
    public isReadyToRender(): boolean {
        return true;
    }

    public componentDidMount() {
        this.handleInit();
    }

    public componentDidUpdate(prevProps: RouteProps) {
        if (prevProps.routeProps.location.pathname !== this.props.routeProps.location.pathname) {
            this.handleInit();
        }
    }

    public handleInit() {
        if (this.props.routeProps.match.url === this.props.routeProps.location.pathname) {
            if (this.props.goBackUrl) {
                this.setState({
                    showMenu: false, // change to true to show close btn
                    iconMenu: menuCloseIcon,
                });
            } else {
                this.setState({
                    showMenu: false,
                });
            }
        } else {
            switch (config.BrandEnv) {
                case 'BMW':
                    this.setState({
                        showMenu: true,
                        iconMenu: menuIconBMW,
                    });
                    break;
                case 'MINI':
                    this.setState({
                        showMenu: true,
                        iconMenu: menuIconMINI,
                    });
                    break;
                default:
                    this.setState({
                        showMenu: true,
                        iconMenu: menuIconBMW,
                    });
                    break;
            }
        }
    }

    public render() {
        const newProps: SideNavProps = {
            showMenu: this.state.showMenu,
            menuIcon: this.state.iconMenu,
            onClick: this.onClick,
            isReadyToRender: this.isReadyToRender(),
            config,
        };

        return this.props.children(newProps);
    }
}

const mapStateToProps = (store: RootState) => ({
    goBackUrl: store.appState.menuGoBackUrl.location,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    authServiceActions: CommonAuthService.Service.bindServiceActionCreators(config, dispatch),
    appActions: bindActionCreators(Actions, dispatch),
    appServiceActions: AppService.bindServiceActionCreators(config, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNavContainer);
